/**
 * The disability categories a student can be assigned as a primary or secondary disability.
 * Numeric values match the ids seeded into K12.StudentDisability by the API, which are what the
 * disability dropdowns bind to.
 */
export enum StudentDisabilityType {
  Autism = 1,
  DevelopmentalDelay = 2,
  HearingImpairment = 3,
  IntellectualDisabilityModerate = 4,
  IntellectualDisabilitySevere = 5,
  MultipleDisabilities = 6,
  VisualImpairmentIncludingBlindness = 7,
  DeafBlindness = 8,
  Deafness = 9,
  IntellectualDisabilityMild = 10,
  EmotionalDisability = 11,
  SpecificLearningDisability = 12,
  SpeechOrLanguageImpairment = 13,
  TraumaticBrainInjury = 14,
  OtherHealthImpairment = 15,
  OrthopedicImpairment = 16
}
